import Layout from "../components/layout/Layout";
import HeroSlideshow from "../components/home/HeroSlideshow";
import StatsPanel from "../components/home/StatsPanel";
import ValueCards from "../components/home/ValueCards";
import CategoryShowcase from "../components/home/CategoryShowcase";
import OpeningGuideTeaser from "../components/home/OpeningGuideTeaser";
import RoomTypeQuick from "../components/home/RoomTypeQuick";
import FeaturedProducts from "../components/home/FeaturedProducts";
import WhyUs from "../components/home/WhyUs";
import SupplyProcess from "../components/home/SupplyProcess";
import FinalCTA from "../components/home/FinalCTA";
import useSeo, { getOrganizationSchema, getConsultingServiceSchema } from "../hooks/useSeo";

export default function Home() {
  const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
  useSeo({
    title: "Otel Pro — Otel Açılış Danışmanlığı & Ekipman Rehberi",
    description: "Otel açılışınız için A'dan Z'ye uzman danışmanlık ve premium ekipman tedariki. Yıldız standartlarına uygun, oda bazlı planlama.",
    canonicalPath: "/",
    jsonLd: [getOrganizationSchema(baseUrl), getConsultingServiceSchema(baseUrl)],
  });

  return (
    <Layout>
      <HeroSlideshow />
      <StatsPanel />
      <ValueCards />
      <CategoryShowcase />
      <OpeningGuideTeaser />
      <RoomTypeQuick />
      <FeaturedProducts />
      <WhyUs />
      <SupplyProcess />
      <FinalCTA />
    </Layout>
  );
}
